import Button from '@material-ui/core/Button';
import Grow from '@material-ui/core/Grow';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { ErrorMessage, useFormikContext } from 'formik';
import React, { useCallback, useRef } from 'react';

const useStyles = makeStyles(
    (theme) => ({
        root: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            width: '100%',
            height: '100%',
            padding: 60,
            zIndex: 22,
            top: 0,
            left: 0,

            '& .MuiButton-label': {
                color: theme.palette.error.main,
                textTransform: 'none !important',
            },

            '&, &:hover': {
                backgroundColor: 'rgba(255, 255, 255, .85)',
            },
        },
    }),
    {
        name: 'FormError',
    },
);

/**
 *
 * @author: Dumitrana Alinus <alinus@wooter.co>
 * @component: FormError
 * @date: 24.01.2021
 * @time: 16:41
 */
export function FormError() {
    const classes = useStyles();
    const formik = useFormikContext<{ error: any }>();
    const tRef = useRef<any>();

    const handleClick = useCallback(() => {
        if (tRef.current) {
            clearTimeout(tRef.current);
        }

        formik.setFieldError('error', null);
        formik.setFieldTouched('error', false);
    }, []);

    const handleEnter = useCallback(() => {
        tRef.current = setTimeout(handleClick, 3000);
    }, [handleClick]);

    return (
        <Grow in={!!(formik.touched.error && formik.errors.error)} unmountOnExit onEntered={handleEnter}>
            <div className={classes.root}>
                <ErrorMessage name={'error'} />

                <Button>OK</Button>
            </div>
        </Grow>
    );
}

export default FormError;
